module.exports = __webpack_public_path__ + "img/28.244d84ef.jpg";